import React from 'react';
import styled from 'styled-components';
import { ToggleSwitch, ToggleInput, ToggleSlider } from '../../ToggleStyles';

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.md};
  padding: ${props => props.theme.spacing.sm} 0;
`;

const TextBlock = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Title = styled.span`
  font-size: ${props => props.theme.typography.sizes.default};
  font-weight: ${props => props.theme.typography.weights.semiBold};
  color: ${props => props.theme.colors.text};
  line-height: 1.3;
`;

const Desc = styled.span`
  font-size: ${props => props.theme.typography.sizes.small};
  color: ${props => props.theme.colors.muted};
  line-height: 1.4;
`;

export const BooleanRow = ({ label, description, checked, onChange, disabled = false }) => {
  const handleChange = (e) => {
    if (disabled) return;
    onChange?.(e.target.checked);
  };

  return (
    <Row>
      <TextBlock>
        <Title>{label}</Title>
        {description && <Desc>{description}</Desc>}
      </TextBlock>
      <ToggleSwitch>
        <ToggleInput
          type="checkbox"
          checked={!!checked}
          onChange={handleChange}
          disabled={disabled}
        />
        <ToggleSlider $checked={!!checked} />
      </ToggleSwitch>
    </Row>
  );
};
